import React from 'react'
import styles from './Footer.module.css'

export default function Footer() {
    return (
        <footer className={styles.footer}>
            <p>運営会社</p>
            <img
                src='/pages/business/foodslabo/cuolega.png'
                alt='株式会社クオレガ'
            />
            <p className={styles.operation}>株式会社クオレガ</p>
            <ul>
                <li>
                    <a
                        target='_blank'
                        rel='noopener noreferrer'
                        href='https://cuolega.co.jp/profile/'
                    >
                        運営会社
                    </a>
                </li>
                <li>
                    <a
                        target='_blank'
                        rel='noopener noreferrer'
                        href='https://cuolega.co.jp/privacy/'
                    >
                        プライバシーポリシー
                    </a>
                </li>
                <li>
                    <a
                        target='_blank'
                        rel='noopener noreferrer'
                        href='https://cuolega.co.jp/terms/'
                    >
                        利用規約
                    </a>
                </li>
            </ul>
            <small>
                COPYRIGHT &copy; 2023 foods labo agent by cuolega ALL RIGHTS
                RESERVED.
            </small>
        </footer>
    )
}
